import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Loader2, RefreshCw, SearchCheck, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg, formatDate, useApi } from "@/lib/api";

export default function CheckPanel({ h, reload }) {
  const api = useApi();
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState("");
  const shown = res || h.last_check;
  const check = async () => {
    setBusy("check");
    try { const { data } = await api.post("/hosting/check"); setRes({ ...data, at: new Date().toISOString() }); toast[data.ok ? "success" : "warning"](data.ok ? "Configurazione corretta" : "Alcuni controlli non sono superati"); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  const sync = async () => {
    setBusy("sync");
    try { const { data } = await api.post("/hosting/sync"); await reload(); data.errors.length ? toast.error(`${data.errors.length} siti non sincronizzati: ${data.errors[0].error}`) : toast.success(`Sincronizzazione completata: ${data.published} siti con indirizzi pubblicati (${data.synced} siti attivati controllati)`); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  return (
    <div className="space-y-3" data-testid="hosting-check">
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" size="sm" onClick={check} disabled={!!busy} data-testid="hosting-check-btn">{busy === "check" ? <Loader2 size={13} className="mr-1 animate-spin" /> : <SearchCheck size={14} className="mr-1" />}Verifica configurazione</Button>
        <Button variant="outline" size="sm" onClick={sync} disabled={!!busy || !h.active} data-testid="hosting-sync-btn">{busy === "sync" ? <Loader2 size={13} className="mr-1 animate-spin" /> : <RefreshCw size={13} className="mr-1" />}Sincronizza i siti attivati</Button>
      </div>
      <p className="text-[11px] text-slate-500">La verifica fa solo letture (nessuna modifica, nessun costo). La sincronizzazione riscrive gli indirizzi dei soli siti con «Pubblica su…» attivo (gli altri non vengono toccati): utile se l'archivio KV è stato svuotato o modificato a mano.</p>
      {shown && (
        <ul className="divide-y divide-slate-100 rounded-lg border border-slate-200" data-testid="hosting-check-results">
          {shown.items.map((i) => (
            <li key={i.key} className="flex items-start gap-2.5 px-4 py-2.5 text-sm" data-testid={`hosting-check-${i.key}`}>
              {i.ok ? <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-emerald-600" /> : <XCircle size={16} className="mt-0.5 shrink-0 text-red-500" />}
              <div className="min-w-0"><p className="text-slate-800">{i.label}</p>{i.detail && <p className={`text-xs break-words ${i.ok ? "text-slate-500" : "text-red-600"}`}>{i.detail}</p>}</div>
            </li>
          ))}
          <li className="px-4 py-2 text-[11px] text-slate-400">Ultima verifica {formatDate(shown.at, true)}</li>
        </ul>
      )}
    </div>
  );
}
